import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".wizard-library---fFUN {\n  height: 100%;\n  border-radius: 1.2rem 1.2rem 0 0;\n  overflow-y: hidden;\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n}\n.wizard-library---fFUN .scrollable-library---yigz {\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  overflow-x: hidden;\n}";
var styles = {"wizard":"wizard-library---fFUN","scrollable":"scrollable-library---yigz"};
styleInject(css_248z);

export { styles as default };
